import { ProfileOverview } from "@/components/candidate/ProfileOverview";
import { Leaderboard } from "@/components/gamification/Leaderboard";
import { NextAchievements } from "@/components/gamification/NextAchievements";
import { ReferralCard } from "@/components/referral/ReferralCard";
import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { DeleteAccountSection } from "@/components/account/DeleteAccountSection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function CandidateDashboard() {
  usePageMeta({
    title: "Dashboard - Data Hire Club",
    description: "Dashboard do candidato",
    noindex: true,
  });

  return (
    <CandidateLayout maxWidth="5xl">
      <div className="space-y-6 md:space-y-8">
        <ProfileOverview />
        <Leaderboard />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <NextAchievements />
          <ReferralCard />
        </div>
        <DeleteAccountSection />
      </div>
    </CandidateLayout>
  );
}
